import React, { FC, PropsWithChildren } from 'react';
import { ThemeHeader } from '@/components/ThemeHeader';
import { classnames } from '@/utils/classnames';

interface IEmptyPageLayoutProps extends PropsWithChildren<{}> {
  className?: string;
  defaultLayout?: boolean;
  childrenClassName?: string;
}

const EmptyPageLayout: FC<IEmptyPageLayoutProps> = ({
  children,
  className = '',
  childrenClassName,
  defaultLayout = false,
}) => {
  if (defaultLayout) {
    <div className="bg-gray-10 page-full" id="__main">
      <div className="mx-auto flex min-h-full flex-row-reverse justify-center gap-6 lg:container md:!px-5 md:!py-4">
        <div className="min-h-full w-full overflow-hidden md:!w-[calc(100%-322px-3rem)] md:!max-w-[480px] lg:!w-[calc(100%-432px-3rem)]">
          <div
            className={
              'relative flex h-full flex-col overflow-auto overflow-x-hidden bg-[#fff] md:!h-auto md:min-h-[489px] md:rounded-2xl lg:min-h-[439px]'
            }
          >
            <div
              className={`relative flex flex-grow flex-col justify-start px-4 py-5 ${className}`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>;
  }

  return (
    <>
      <ThemeHeader />
      <main
        className={`z-[99998] flex justify-center bg-[#fff] page-full ${className}`}
      >
        <div
          className={classnames(
            'flex max-w-[472px] flex-1 flex-col items-center justify-between px-5 pb-7 pt-6 children:w-full',
            childrenClassName
          )}
        >
          {children}
        </div>
      </main>
    </>
  );
};

export default EmptyPageLayout;
